import React, { useState } from "react";
import { Typography, Grid, Paper, TextField, Button } from "@material-ui/core";
import { Formik, Form, ErrorMessage } from "formik";
import * as yup from "yup";
import { useSuspendedBillStyles } from "../useSuspendedBillStyles";
import { api } from "../../../api";
import { SnackBar } from "../../SnackBar";
import { SuspendedBillDetails } from "./SuspendedBillDetails";
import { AppLoadingScreen } from "../../AppLoadingScreen";

export const SuspendedBillSearch = () => {
  const classes = useSuspendedBillStyles();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");
  const [detailFlag, setDetailFlag] = useState<boolean>(false);
  const [suspendedBillDetails, setSuspendedBillDetails] = useState<Array<object>>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

 

  const getBillDetails = async ( billDocNo: string) => {
    try {
      setIsLoading(true);
      const billDetails = await api.get(`bills/${billDocNo}/suspended-product-list`);
      setSuspendedBillDetails(billDetails);
      setDetailFlag(true);
      setIsLoading(false);
    
    } catch (error:any) {
      setSnackbarColor("red");
      setErrorMessage(error.error);
    }
  };

  const onCloseSnackbar = () => {
    setErrorMessage("");
  };

  return (
    <div className={classes.root}>
        <SnackBar
        status={errorMessage}
        onCloseError={onCloseSnackbar}
        color={snackbarColor}
      />
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Formik
              enableReinitialize
              initialValues={{
                bill_number: "",
              }}
              validationSchema={yup.object().shape({
                bill_number: yup.string().required("Required")
              })
              }
              onSubmit={async (values) => {       
                  getBillDetails(values.bill_number) 
              }}
            >
              {({ values, handleChange }) => (
                <Form>
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    spacing={1}
                  >
                    <Grid item xs={6}>
                      <Grid container direction="column">
                        <Typography style={{ textAlign: "left" }}>
                          Enter Bill Number <span style={{color:"red"}}>*</span>
                        </Typography>
                        <TextField
                          variant="outlined"
                          name="bill_number"
                          onChange={handleChange}
                          value={values.bill_number}
                        />
                        
                        <ErrorMessage name="bill_number">
                          {(msg) => (
                            <div className={classes.textFieldErrorMessageStyle}>{msg}</div>
                          )}
                        </ErrorMessage>
                      </Grid>
                    </Grid>
                    <Grid item xs={3} sm="auto" style={{ paddingTop: "2em" }}>
                    <div className={classes.wrapper}>
                      <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={isLoading}
                      >
                        Show Bill Details
                      </Button>
                </div>
                    </Grid>
                    <Grid item xs={3} sm="auto" style={{ paddingTop: "2em" }}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setDetailFlag(false);
                            setSuspendedBillDetails([]);
                            setIsLoading(false);
                        }}
                        type="reset"
                      >
                        Clear
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
            <Grid item xs={12} style={{paddingTop:"2em"}}>
            {isLoading === true ? (
              <AppLoadingScreen />
             ) : (
            detailFlag?(
                <SuspendedBillDetails
                suspendedBillDetails={suspendedBillDetails}
                billDetails={[]}
                backToList={()=>{}}
                searchView={true}
                voucherValidity={""}
                listType={""}
              />
            ):"")}
            </Grid>
          </Grid>
        </Grid>
    </div>
  );
};
